import React, { FC, useCallback } from 'react'

import styles from '../Story.module.scss'
import { useStoryContext } from '../StoryContext'
import { CommentContainer } from './Comment/CommentContainer'
import { useCommentActions } from '../hooks'
import { StoryDivider } from './StoryDivider'
import EditComment from '../../../modules/Feed/components/Comment/EditComment'
import { Comment } from '../../../shared/__gql-types'

type TStoryCommentsProps = {
  commentsFilterFn?: (comment: Comment) => boolean
  allowCreation?: boolean
  allowEditing?: boolean
  allowDeletion?: boolean
  assignNewCommentsToProjectId?: string
}


export const StoryComments: FC<TStoryCommentsProps> = (props) => {
  const story = useStoryContext()

  const { createCommentMutation, editCommentMutation, deleteCommentMutation, loading } = useCommentActions()
  let comments
  if (typeof props.commentsFilterFn === 'function') {
    comments = story.comments?.filter(props.commentsFilterFn) ?? []
  } else {
    comments = story.comments ?? []
  }

  const handleCommentCreation = useCallback(async (commentText: string) => {
    console.log('handleCommentCreation', {
      storyId: story.id,
      comment: commentText,
      project_id: props.assignNewCommentsToProjectId
    })
    return createCommentMutation({
      variables: {
        storyId: story.id,
        comment: commentText,
        project_id: props.assignNewCommentsToProjectId
      },
      update(cache, { data }) {
        if (!data) return
        const cacheId = cache.identify(data.createComment)
        if (!cacheId) return
        cache.modify({
          id: `Feed:${story.id}`,
          fields: {
            comments(existingComments = [], { toReference }) {
              return [...existingComments, toReference(cacheId)]
            }
          }
        })
      }
    })
  }, [createCommentMutation, props.assignNewCommentsToProjectId, story.id])
  const handleCommentEditing = useCallback(async (commentId: string, commentText: string) => {
    return editCommentMutation({
      variables: {
        id: commentId,
        text: commentText
      }
    })
  }, [editCommentMutation])
  const handleCommentDeletion = useCallback(async (commentId: string) => {
    return deleteCommentMutation({
      variables: {
        id: commentId
      },
      update(cache) {
        cache.evict({ id: `Feed:${story.id}`, fieldName: 'comments' })
      }
    })
  }, [deleteCommentMutation, story.id])

  return (
    <div className={styles.commentsList}>
      {comments.map((comment) => {
        return (
          <CommentContainer
            key={comment.id}
            loading={loading}
            comment={comment}
            allowEditing={props.allowEditing}
            allowDeletion={props.allowDeletion}
            onEdit={async (value) => handleCommentEditing(comment.id, value)}
            onDelete={async () => handleCommentDeletion(comment.id)}
          />
        )
      })}
      {props.allowCreation === true && (
        <>
          <StoryDivider />
          <EditComment loading={loading} onSubmit={handleCommentCreation} text={''} />
        </>
      )}
    </div>
  )
}


